<!--begin::Subheader-->
<div class="subheader py-2 py-lg-6" [ngClass]="subheaderCSSClasses" id="kt_subheader">
	<div [ngClass]="subheaderContainerCSSClasses" class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
		<!--begin::Info-->
		<div class="d-flex align-items-center flex-wrap mr-1">
			<ng-container *ngIf="subheaderMobileToggle">
				<!--begin::Mobile Toggle-->
				<button class="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none" id="kt_subheader_mobile_toggle">
					<span></span>
				</button>
				<!--end::Mobile Toggle-->
			</ng-container>

			<!--begin::Page Heading-->
			<div class="d-flex align-items-baseline flex-wrap mr-5">
				<!--begin::Page Title-->
				<ng-container *ngIf="title$ | async as _title">
					<h5 class="text-dark font-weight-bold my-1 mr-5">
						{{ _title.length > 50 ? (_title | slice : 0 : 50) + "..." : _title }}
					</h5>
				</ng-container>
				<!--end::Page Title-->

				<!--begin::Breadcrumb
				<ul class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2 font-size-sm">
					<li class="breadcrumb-item" *ngFor="let bc of breadcrumbs" routerLinkActive="active">
						 <a [routerLink]="bc.linkPath" class="text-muted">
              {{ bc.linkText }}
            </a> 
						<a [routerLink]="" class="text-muted" style="color: #b5b5c3 !important">
							{{ bc.linkText }}
						</a>
					</li>
				</ul>-->
				<!-- Divisas Widget Removed -->
				<!--end::Breadcrumb-->

				<!-- factura guias removed -->
				<!-- Folios badge removed -->

				<!-- end factura guias -->
			</div>
			<!--end::Page Heading-->
		</div>
		<!--end::Info-->

		<!--begin::FOLIOS-->
		<!-- <div class="mr-0" *ngIf="showFacturacionButtonGroup">
         <div class="row justify-content-center pulse">
            <ng-container *ngIf="!(loadingFoliosSummary$ | async)">
               <span
                  style="cursor: default"
                  ngbToolTip="Folios disponibles"
                  *ngIf="nombreTipoDteDisponible != ''"
                  class="btn text-light col-auto badge-pill"
                  [ngClass]="{
                     'badge-danger': cantidadTipoDteDisponible == 0,
                     'badge-primary': cantidadTipoDteDisponible != 0
                  }"
                  >Folios {{ nombreTipoDteDisponible }}: {{ cantidadTipoDteDisponible }}</span
               >
               <ng-container *ngIf="nombreTipoDteDisponible != '' && cantidadTipoDteDisponible == 0">
                  <span class="pulse pulse-ring border-danger"></span>
               </ng-container>

               <span style="cursor: default" ngbToolTip="Folios no disponibles" *ngIf="(currentTipoCantidad && nombreTipoDteDisponible == '' && cantidadTipoDteDisponible == 0) || !currentTipoCantidad" class="btn text-light col-auto badge-pill badge-danger">Sin folios</span>
            </ng-container>

            <ng-container *ngIf="loadingFoliosSummary$ | async">
               <div class="row">
                  <div class="col-1">
                     <span class="spinner spinner-primary spinner-lg"></span>
                  </div>
               </div>
            </ng-container>
         </div>
      </div> -->
		<!--end::FOLIOS-->
		<!--begin::Toolbar-->
		<div class="d-flex align-items-center">
			<div class="mr-3" *ngIf="showButton && !showFacturacionButtonGroup && !showBheButtonGroup">
				<!--eliminar el evento click -->
				<button type="button" class="btn btn-sm buttonOption" data-gtm-group="ClientePayku" title="Cliente Payku" style="background-color: #6f42c1; color: white; border: 1px solid #6f42c1; cursor: default; pointer-events: none">
					<span class="d-none d-md-inline ml-2">Cliente Payku</span>
					<i class="fa fa-trophy ml-2" style="color: #ffc107" title="Cliente Payku con DTE Pagado"></i>
				</button>
			</div>
			<div
				*ngIf="!hasReseller"
				class="mt-5"
				[ngClass]="{
					'espacio-boton-soporte': showFacturacionButtonGroup || showBheButtonGroup
				}">
				<div ngbDropdown>
					<button ngbDropdownToggle id="dropdownDtes" class="btn btn-outline-success mb-5 mr-5">
						<i class="fa-regular fa-headset"></i>
						Contacto con Soporte
					</button>
					<div ngbDropdownMenu aria-labelledby="dropdownDescargas" class="dropdown-menu__soporte">
						<button ngbDropdownItem (click)="openClickfono()"><i class="fa-light fa-phone-arrow-up-right mr-2"></i> Hablemos por Fono</button>
						<button ngbDropdownItem (click)="openWhatsapp()"><i class="fa-brands fa-whatsapp mr-2"></i> Hablemos por Whatsapp</button>
					</div>
				</div>
				<!-- <button class="btn btn-outline-success mb-5 mr-5">
               <i class="fa-regular fa-headset"></i>
               Contacto con Soporte
            </button> -->
			</div>
			<!--begin::Accessibility Button-->
			<div class="mr-3 d-none d-lg-block">
				<button type="button" class="btn btn-outline-primary btn-sm buttonOption" style="padding: 10px;" data-gtm-group="accessibility" (click)="openAccessibilityModal()" title="Opciones de Accesibilidad" aria-label="Abrir opciones de accesibilidad">
					<i class="fas fa-universal-access"></i>
					<span class="d-none d-md-inline ml-2">Accesibilidad</span>
				</button>
			</div>
			<!--end::Accessibility Button-->

			<ng-container *ngIf="subheaderDisplayDaterangepicker">
				<!--begin::Daterange-->
				<a class="btn btn-light-primary btn-sm font-weight-bold mr-2 cursor-pointer" id="kt_dashboard_daterangepicker" data-toggle="tooltip" title="Select dashboard daterange" data-placement="left">
					<span class="opacity-60 font-weight-bold mr-2" id="kt_dashboard_daterangepicker_title">Today</span>
					<span class="font-weight-bold" id="kt_dashboard_daterangepicker_date">Aug 16</span>
				</a>
				<!--end::Daterange-->
			</ng-container>
			<ng-container *ngIf="!subheaderDisplayDaterangepicker">
				<!--begin::Actions-->
				<!-- <a
          class="btn btn-light-primary font-weight-bolder btn-sm cursor-pointer"
        >
          Actions
        </a> -->
				<!--end::Actions-->
			</ng-container>

			<ng-container *ngIf="showBheButtonGroup">
				<div class="mt-5">
					<button id="boton_generar_bhe" class="btn btn-success mb-5 mr-5" (click)="sendEmitBheAction()">
						<i class="flaticon-file-2"></i>
						Generar
					</button>
					<button class="btn btn-danger mb-5 mr-5" (click)="sendCancelBheAction()">Cancelar</button>
				</div>
			</ng-container>
			<ng-container *ngIf="showFacturacionButtonGroup">
				<div class="mt-5 d-none d-md-block">
					<div class="btn-group mb-5 mr-5 generar-dropdown" id="grupo_boton_generar" ngbDropdown display="static">
						<button id="boton_generar_factura" class="btn btn-success" (click)="sendEmitAction()">
							<i class="fa-solid fa-file-check"></i>
							Generar
						</button>
						<button type="button" id="boton_generar_opciones" ngbDropdownToggle class="btn btn-success dropdown-toggle dropdown-toggle-split generar-dropdown__toggle" title="Más opciones de emisión" aria-label="Mostrar opciones de generación">
							<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
							<span class="sr-only">Más opciones</span>
						</button>
						<div ngbDropdownMenu class="generar-dropdown__menu">
							<button ngbDropdownItem id="boton_generar_factura_dropdown" (click)="sendEmitAction()">Generar</button>
							<button ngbDropdownItem id="boton_generar_guardar_frecuente" (click)="sendEmitAndSaveAction()">Generar y guardar frecuente</button>
						</div>
					</div>
					<button id="boton_preview" class="btn btn-primary mb-5 mr-5" (click)="sendPreviewAction()">
						<i class="fa-solid fa-magnifying-glass-dollar"></i>
						Previsualizar
					</button>
					<button id="boton_cancelar" class="btn btn-danger mb-5 mr-5" (click)="sendCancelAction()"><i class="fa-sharp fa-regular fa-ban"></i> Cancelar</button>
				</div>
				<div class="mt-5 d-md-none">
					<div class="btn-group mb-5 mr-5 generar-dropdown" id="grupo_boton_generar2" ngbDropdown display="static">
						<button class="btn btn-success" id="boton_generar_factura2" (click)="sendEmitAction()">
							<i class="fa-solid fa-file-check"></i>
						</button>
						<button type="button" id="boton_generar_opciones2" ngbDropdownToggle class="btn btn-success dropdown-toggle dropdown-toggle-split generar-dropdown__toggle" title="Más opciones de emisión" aria-label="Mostrar opciones de generación">
							<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
							<span class="sr-only">Más opciones</span>
						</button>
						<div ngbDropdownMenu class="generar-dropdown__menu">
							<button ngbDropdownItem (click)="sendEmitAction()">Generar</button>
							<button ngbDropdownItem (click)="sendEmitAndSaveAction()">Generar y guardar frecuente</button>
						</div>
					</div>
					<button class="btn btn-primary mb-5 mr-5" id="boton_preview2" (click)="sendPreviewAction()">
						<i class="fa-solid fa-magnifying-glass-dollar"></i>
					</button>
					<button class="btn btn-danger mb-5 mr-5" id="boton_cancelar2" (click)="sendCancelAction()">
						<i class="fa-sharp fa-regular fa-ban"></i>
					</button>
				</div>
			</ng-container>
		</div>
		<!--end::Toolbar-->
	</div>
</div>
<!--end::Subheader-->

<!--begin::Accessibility Modal-->
<div class="d-none d-lg-block">
	<app-accessibility-modal [isVisible]="isAccessibilityModalVisible" (close)="closeAccessibilityModal()"> </app-accessibility-modal>
</div>
<!--end::Accessibility Modal-->

<app-simple-fono-modal *ngIf="isSimpleFonoModalVisible" [origin]="simpleFonoOrigin" [showAreas]="simpleFonoShowAreas" [fixedAreaCode]="simpleFonoFixedAreaCode" (close)="closeSimpleFonoModal()">
</app-simple-fono-modal>
